(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
// Rotate the announcements. Pauses when the tab is hidden so the messages
// aren't all consumed while nobody is looking.
(function () {
  var items = document.querySelectorAll('.announcement__item');
  if (items.length < 2) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var index = 0;
  setInterval(function () {
    if (document.hidden) return;
    items[index].classList.remove('is-active');
    index = (index + 1) % items.length;
    items[index].classList.add('is-active');
  }, 4200);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function () {
  var header = document.querySelector('[data-header]');
  var toggle = document.querySelector('[data-menu-toggle]');
  var menu = document.querySelector('[data-menu]');

  // Shadow the header only once the page has actually scrolled.
  if (header) {
    var sentinel = document.createElement('div');
    sentinel.style.cssText = 'position:absolute;top:0;height:1px;width:1px;';
    document.body.prepend(sentinel);
    new IntersectionObserver(function (entries) {
      header.classList.toggle('is-stuck', !entries[0].isIntersecting);
    }).observe(sentinel);
  }

  if (!toggle || !menu) return;

  function setOpen(open) {
    menu.hidden = !open;
    toggle.setAttribute('aria-expanded', String(open));
    toggle.innerHTML = open
      ? '<span class="visually-hidden">Close menu</span>' + iconClose
      : '<span class="visually-hidden">Menu</span>' + iconMenu;
  }

  var iconMenu = toggle.innerHTML.replace(/<span[^>]*>.*?<\/span>/, '');
  var iconClose = iconMenu
    .replace(/<path[^>]*\/?>/g, '')
    .replace('</svg>', '<path d="M5.5 5.5 18.5 18.5M18.5 5.5 5.5 18.5"/></svg>');

  toggle.addEventListener('click', function () {
    setOpen(menu.hidden);
  });

  // Anchor links inside the drawer should close it on the way to the target.
  menu.querySelectorAll('[data-menu-link]').forEach(function (link) {
    link.addEventListener('click', function () { setOpen(false); });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !menu.hidden) {
      setOpen(false);
      toggle.focus();
    }
  });

  // A resize past the desktop breakpoint leaves the drawer orphaned.
  var desktop = window.matchMedia('(min-width: 62rem)');
  desktop.addEventListener('change', function (event) {
    if (event.matches) setOpen(false);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
